import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useLocation, useParams } from "react-router-dom";
import config from "../../config/config";
import moment from "moment";
import { event } from "jquery";
import { set } from "react-hook-form";
import jsPDF from "jspdf";
import CryptoJS from "crypto-js";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../DatePicker/CommonDatePicker";

const PurchaseStatement = ({ customerid, ecomuser }) => {
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const Location = localStorage.getItem("Location");

  console.log(customerid, ecomuser, "0147");

  let location = useLocation();

  console.log(location.pathname.split("/")[1], "pageloaction");

  const ComponentURl = location.pathname.split("/")[1] === "customerstatement";

  console.log(ComponentURl, "ComponentURl");
  // console.log(paramObject, "jjjjjjjjjjjj");

  //   const decrypted2 = CryptoJS.AES.decrypt( paramObject?.id, config.portalSendIdKey);
  //  const decryptedData = decrypted2.toString(CryptoJS.enc.Utf8);
  //     const parseddata = decryptedData ? JSON.parse(decryptedData) : null;

  //     console.log(parseddata, "parse customer id")

  const [customerDetails, setCustomerDetails] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [dateFilter, setDateFilter] = useState();
  const [beginningDate, setBeginningDate] = useState( moment().startOf("month").format("YYYY-MM-DD"));
  const [finalDate, setFinalDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));
  const [startDate, setStartDate] = useState( moment().startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));
  const columns = [
    {
      name: "Date",
      width: "160px",
      selector: (row) => moment(row["Date"]).format("MM/DD/YYYY "),
      sortable: false,
    },
    {
      name: "Details",
      width: "420px",
      selector: (row) => {
        return <div style={{ width: "320px" }}>{row["Details"]}</div>;
      },
      sortable: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "60px",
          }}
        >
          Credit
        </div>
      ),
      selector: (row) => {
        return (
          <div className="text-right" style={{ width: "98px" }}>
            {row?.Payments}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "60px",
          }}
        >
          Debit
        </div>
      ),
      selector: (row) => {
        return (
          <div className="text-right" style={{ width: "108px" }}>
            {row?.Amount}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "33px",
          }}
        >
          Balance
        </div>
      ),
      width: "130px",
      selector: (row) => {
        return (
          <div className="text-right" style={{ width: "98px" }}>
            {row?.Balance}
          </div>
        );
      },
      sortable: true,
    },
  ];
  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "This Month",
    value: 3,
  });
  const options = [
    { label: "Today", value: 1 },
    { label: "Last Year", value: 2 },
    { label: "This Month", value: 3 },
    { label: "This Week", value: 4 },
    { label: "This Year", value: 5 },
    { label: "Last Month", value: 6 },
    { label: "Custom", value: 7 },
  ];

  //Date

  //Today
  let today = moment().format("YYYY-MM-DD");
  //Week
  const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  //This Month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");
  //This Year
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("YYYY-MM-DD");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");

  const handleQuickBookChange = (event) => {
    console.log(event, "eventtt");
    setDateFilter(event?.value);
    if (event?.value !== 7) {
      setStartDate(moment().format("YYYY-MM-DD"));
      setEndDate(moment().format("YYYY-MM-DD"));
    }
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    }
  };

  // const handleDate = (event) => {
  //   console.log(event?.target?.value, "eventisss92");
  //   setStartDate(event?.target?.value);
  //   setBeginningDate(event?.target?.value);
  // };


  const handleDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      // const datetime =
      //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      setStartDate(selectedDate);
      setBeginningDate(selectedDate);
    }
  };


  // const handleEndDate = (event) => {
  //   setEndDate(event?.target?.value);
  //   setFinalDate(event?.target?.value);
  // };

  const handleEndDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      // const datetime =
      //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      setEndDate(selectedDate);
      setFinalDate(selectedDate);
    }
  };


  //Serach Button
  const handleSearch = () => {
    console.log(startDate, endDate, "1555");
    customerStatementAPI(startDate, endDate);
  };

  const dateFilterData =
    dateFilter == 1 ? (
      <p>{moment(today).format('MM-DD-YYYY') + " To " + moment(today).format('MM-DD-YYYY')}</p>
    ) : dateFilter === 4 ? (
      <p>{moment(startOfWeek).format('MM-DD-YYYY') + " To " + moment(endOfWeek).format('MM-DD-YYYY')}</p>
    ) : dateFilter === 3 ? (
      <p>{moment(startOfMonth).format('MM-DD-YYYY') + " To " + moment(endOfMonth).format('MM-DD-YYYY')}</p>
    ) : dateFilter === 6 ? (
      <p>{moment(startOfLastMonth).format('MM-DD-YYYY') + " To " + moment(endOfLastMonth).format('MM-DD-YYYY')}</p>
    ) : dateFilter === 5 ? (
      <p>{moment(startOfYear).format('MM-DD-YYYY') + " To " + moment(endOfYear).format('MM-DD-YYYY')}</p>
    ) : dateFilter === 2 ? (
      <p>{moment(startOfLastYear).format('MM-DD-YYYY') + " To " + moment(endOfLastYear).format('MM-DD-YYYY')}</p>
    ) : dateFilter === 7 ? (
      startDate === undefined ? (
        <p>{moment(today).format('MM-DD-YYYY') + " To " + moment(today).format('MM-DD-YYYY')}</p>
      ) : (
        <p>{moment(startDate).format('MM-DD-YYYY') + " To " + moment(endDate).format('MM-DD-YYYY')}</p>
      )
    ) : (
      <p>{moment(startOfMonth).format('MM-DD-YYYY') + " To " + moment(endOfMonth).format('MM-DD-YYYY')}</p>
    );

  const customerStatementAPI = () => {
    let sDate = beginningDate == undefined ? startOfYear : beginningDate;
    let fDate = finalDate == undefined ? endOfYear : finalDate;
    axios
      .get(
        `${config.customersBaseUrl}/customers/${
          ComponentURl ? "ecomcustomerstatement" : "customerstatement"
        }?customerid=${
          ecomuser ? customerid : paramObject.id
        }&startdate=${sDate}&enddate=${fDate}&Locationid=${Location}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setCustomerDetails(res?.data?.ResponseData?.CustomerDetails);
        setCustomerList(res?.data?.ResponseData?.StatementList);
      });
  };

  useEffect(() => {
    customerStatementAPI();
  }, [dateFilter]);

  // Print Statement Function-
  const handlePrint = () => {
    var doc = new jsPDF("p", "pt", "a4");

    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `8px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let dateHeaderElement = document.querySelector("#date-header");
    let clonedDateHeader = dateHeaderElement.cloneNode(true);
    clonedDateHeader.style.fontSize = `8px`;
    clonedDateHeader.style.width = "560px";
    document.querySelector("#date-header p").style.margin = 0;

    let content = "";
    let startIndex = 0;
    let endIndex = 17;

    content += " " + clonedHeader.outerHTML;

    // Loop through the customerList array
    for (var i = 0; i < Math.ceil(customerList.length / 24); i++) {
      if (i > 0) {
        content += " " + clonedDateHeader.outerHTML;
        clonedDateHeader.style.marginTop = "3rem";
      }

      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">S.No.</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Date</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Details</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Amount</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Payments</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (
        let index = startIndex;
        index < customerList.length && index <= endIndex;
        index++
      ) {
        content +=
          "<tr style='border-bottom: 0.5px solid  #f2f2f2; padding-top: 5px'>" +
          '<td style="font-size: 8px; padding: 8px;font-family: Inter, sans-serif;">' +
          (index + 1) +
          "</td>" +
          '<td style="font-size: 8px; padding: 8px;font-family: Inter, sans-serif;">' +
          moment(customerList[index].Date).format("DD/MM/YYYY") +
          "</td>" +
          '<td style="font-size: 8px; padding: 8px; width: 300px;font-family: Inter, sans-serif;">' +
          customerList[index].Details +
          "</td>" +
          '<td style="font-size: 8px; padding: 8px;font-family: Inter, sans-serif;">' +
          customerList[index].Amount +
          "</td>" +
          '<td style="font-size: 8px; padding: 8px;font-family: Inter, sans-serif;">' +
          customerList[index].Payments +
          "</td>" +
          '<td style="font-size: 8px; padding: 8px;font-family: Inter, sans-serif;">' +
          customerList[index].Balance +
          "</td>" +
          "</tr>";
      }

      content += "</tbody>";
      content += "</table>";

      // Update startIndex and endIndex for the next iteration
      startIndex = endIndex + 1;
      endIndex = startIndex + 24;
    }

    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
      },
    });
  };

  // Send Mail Function-
  const handleMailPdf = () => {
    var doc = new jsPDF("p", "pt", "a4");

    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `8px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";
    clonedHeader.style.marginTop = "20px";

    let dateHeaderElement = document.querySelector("#date-header");
    let clonedDateHeader = dateHeaderElement.cloneNode(true);
    clonedDateHeader.style.fontSize = `8px`;
    clonedDateHeader.style.width = "560px";
    document.querySelector("#date-header p").style.margin = 0;

    let content = "";
    let startIndex = 0;
    let endIndex = 18;
    let counter = 0;

    content += " " + clonedHeader.outerHTML;

    // Loop through the customerList array
    for (var i = 0; i < Math.ceil(customerList.length / 27); i++) {
      if (i >= 0) {
        content += " " + clonedDateHeader.outerHTML;
        clonedDateHeader.style.marginTop = "4rem";
      }

      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Sr No.</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Date</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif width: 300px">Details</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Amount</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Payments</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (
        let index = startIndex;
        index < customerList.length && index <= endIndex;
        index++
      ) {
        content +=
          "<tr>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          (index + 1) +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          moment(customerList[index].Date).format("MM/DD/YYYY ") +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px; width: 300px">' +
          customerList[index].Details +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          customerList[index].Amount +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          customerList[index].Payments +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          customerList[index].Balance +
          "</td>" +
          "</tr>";
      }

      content += "</tbody>";
      content += "</table>";

      // Update startIndex and endIndex for the next iteration
      startIndex = endIndex + 1;
      endIndex = startIndex + 26;
    }

    doc.html(content, {
      callback: function (pdf) {
        const pdfBlob = pdf.output("blob");

        // Create a data URL from the PDF Blob
        const pdfDataUrl = URL.createObjectURL(pdfBlob);

        // Prepare the email subject and body
        const emailSubject = encodeURIComponent("");
        const emailBody = encodeURIComponent("");

        // Create the mailto link with the PDF data URL as attachment
        const mailtoLink = `mailto:?subject=${emailSubject}&body=${emailBody}&attachment=${pdfDataUrl}`;

        // Open the default email client (Gmail) with the mailto link
        window.location.href = mailtoLink;
      },
    });
  };

  //  return
  return (
    <div className={"col-lg-12 col-md-12"}>
      <div className="card bg-white" style={{ borderRadius: "10px" }}>
        <div style={{ fontWeight: "300", margin: "10px 0 0 10px" }}>
          <h4 className="card-title">Customer Statement</h4>
        </div>
        <hr style={{ color: "#cfcfcf" }} />
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <div style={{ width: "20%", marginLeft: "20px" }}>
            Date Filter:
            <Select
              defaultValue={quickBookOptions}
              onChange={(event) => {
                handleQuickBookChange(event);
              }}
              options={options}
              backspaceRemovesValue={false}
              controlShouldRenderValue={true}
              // isClearable={true}
              hideSelectedOptions={true}
            />
          </div>
          {dateFilter === 7 && (
            <>
              <div style={{ width: "20%", marginTop: "3px" }}>
                Start Date:-
                {/* <Flatpickr
                  type="date"
                  className="form-control"
                  id="StartDate"
                  name="StartDate"
                  // value={startDate}
                    value={
                        moment(startDate).format(
                          "YYYY-MM-DDT00:00:00.000"
                        ) + "Z"
                      }
                  // defaultValue={todayDate}
                  onChange={(event) => handleDate(event)}
                    options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                /> */}

<CommonDatePicker FinalDate={startDate} handleDateChange={handleDate}/>

              </div>
              <div style={{ width: "20%", marginTop: "3px" }}>
                End Date:-
                {/* <Flatpickr
                  type="date"
                  className="form-control"
                  id="EndDate"
                  name="EndDate"
                  min={startDate}
                  // value={endDate}
                    value={
                        moment(endDate).format(
                          "YYYY-MM-DDT00:00:00.000"
                        ) + "Z"
                      }
                  onChange={(event) => handleEndDate(event)}
                    options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                /> */}

<CommonDatePicker FinalDate={endDate} handleDateChange={handleEndDate}/>
              </div>
              <button
                className="btn btn-primary"
                style={{
                  height: "fit-content",
                  marginTop: "22px",
                }}
                onClick={(e) => handleSearch(e)}
              >
                Search
              </button>
            </>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginRight: "20px",
            }}
          >
            <div
              style={{
                marginTop: "8px",
                padding: "6px 12px",
                borderRadius: "4px",
                marginRight: "5px",
                cursor: "pointer",
                color: "#415164",
                backgroundColor: "#f1f5f7",
                textTransform: "uppercase",
                fontSize: "13.5px",
              }}
            >
              <i className="fa fa-print" onClick={handlePrint} />
            </div>
            <div
              style={{
                marginTop: "8px",
                padding: "6px 12px",
                borderRadius: "4px",
                marginRight: "5px",
                cursor: "pointer",
                color: "#415164",
                backgroundColor: "#f1f5f7",
                textTransform: "uppercase",
                fontSize: "13.5px",
              }}
            >
              <i className="fa fa-envelope" onClick={handleMailPdf} />
            </div>
          </div>
        </div>

        {/* Print Statememt */}
        <div className="card-body" id="print">
          <div
            style={{
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            {/* Header */}
            <div id="header">
              <div className="text-right">
                {customerDetails?.map((el) => {
                  return (
                    <>
                      <p
                        className="h-tag"
                        style={{
                          fontWeight: "bold",
                          margin: "0",
                          fontFamily: "Inter, sans-serif",
                        }}
                      >
                        {el?.Companyname}
                      </p>
                      <span style={{ fontFamily: "Inter, sans-serif" }}>
                        {el?.Address1 + " " + el?.Address2}
                      </span>
                      <br />
                      <span style={{ fontFamily: "Inter, sans-serif" }}>
                        {el.City &&
                          el.State &&
                          el.Country &&
                          el?.Zip &&
                          el.City + ", " + el.State + ' ' + el?.Zip + ", " + el.Country}
                      </span>

                      <br />
                      {/* <span style={{ fontFamily: "Inter, sans-serif" }}>
                        
                      </span> */}
                    </>
                  );
                })}
              </div>
              <hr style={{ color: "#cfcfcf" }} />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontFamily: "Inter, sans-serif",
                }}
              >
                {customerDetails?.map((el) => {
                  return (
                    <div
                      style={{
                        width: "22%",
                        display: "flex",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      <div>
                        <strong>To: </strong>
                        {el?.FirstName + " " + el?.LastName}
                      </div>
                    </div>
                  );
                })}
                <div className="text-right">
                  <strong>Account Summary</strong>
                  {dateFilterData}
                </div>
              </div>
              <hr
                style={{ width: "20%", marginLeft: "auto", color: "#cfcfcf" }}
              />
              <div>
                {customerDetails?.map((el) => {
                  return (
                    <>
                      <div>
                        <span className="text-left">
                          <strong> Opening  Balance:</strong>$
                          {el?.BeginningBalance > 0 ? el?.BeginningBalance : 0}
                        </span>
                        <span className="text-left">
                          <strong>| Invoiced Amount: </strong>$
                          {el?.InvoicedAmount > 0 ? el?.InvoicedAmount : 0}
                        </span>
                        <span className="text-left">
                          <strong>| Journal Debits:</strong>$
                          {el?.JournalDebitsAmount > 0
                            ? el?.JournalDebitsAmount
                            : 0}
                        </span>
                        <span className="text-left">
                          <strong>| Amount Paid:</strong>$
                          {el?.AmountPaid > 0 ? el?.AmountPaid : 0}
                        </span>
                        <span className="text-left">
                          <strong>| Credit Memo:</strong>$
                          {el?.CreditAppliedAmount > 0
                            ? el?.CreditAppliedAmount
                            : 0}
                        </span>
                        <span className="text-left">
                          <strong>| Journal Credits:</strong>$
                          {el?.JournalCreditsAmount > 0
                            ? el?.JournalCreditsAmount
                            : 0}
                        </span>
                        {/* <span className="text-left">
                          <strong>| Credit Used:</strong>$
                          {el?.CreditUsed > 0 ? el.CreditUsed : 0}
                        </span> */}
                      </div>
                      <div></div>
                      <hr
                        style={{
                          width: "20%",
                          color: "#cfcfcf",
                        }}
                      />

                      <div className="text-left">
                        <strong>Balance Due: </strong>${el?.BalanceDue}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>

            {/* Date Header */}
            <div
              id="date-header"
             
              style={{ textAlign: "center", margin: "20px 0 20px 0" }}
            >
              <strong className="col-md-12">Date Range {dateFilterData}</strong>
            </div>
            

            {/* Table Body */}
            <div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={customerList}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  sortServer
                  dense
                />
              </div>
              <div
                style={{
                  textAlign: "right",
                  marginTop: "2rem",
                }}
              >
                {customerDetails?.map((el) => (
                  <p style={{ margin: "1rem" }}>
                    <strong>Balance Due </strong>{" "}
                    <span style={{ marginLeft: "2rem" }}>
                      ${el?.BalanceDue}
                    </span>
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseStatement;
